/**
 * 公式记法着色 + 步骤 chips
 * 记法字母按所属面着色（六色语法高亮）：R=红 L=橙 U=黄 D=白 F=绿 B=蓝
 */

/** 单个记法 token 的着色 class */
export function moveColorClass(token: string): string {
  const f = token[0]?.toUpperCase();
  return 'UDFRLB'.includes(f) ? `move-${f}` : '';
}

/** 行内着色公式（如正文/状态栏里展示） */
export function ColoredFormula({ tokens, className = '' }: { tokens: string[]; className?: string }) {
  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-2 ${className}`}>
      {tokens.map((t, i) => (
        <span key={i} className={`formula-token ${moveColorClass(t)}`}>
          {t}
        </span>
      ))}
    </span>
  );
}

/** 步骤条：起点 + 每步一枚 chip；done/current 发光态 */
export function StepChips({
  tokens,
  cursor,
  onJump,
}: {
  tokens: string[];
  cursor: number;
  onJump: (n: number) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      <button
        className={`chip ${cursor === 0 ? 'current' : ''}`}
        style={{ fontFamily: 'var(--font-body)' }}
        onClick={() => onJump(0)}
        title="回到起点"
      >
        起点
      </button>
      {tokens.map((t, i) => {
        const n = i + 1;
        const cls = n === cursor ? 'current' : n < cursor ? 'done' : '';
        return (
          <button
            key={i}
            className={`chip ${cls} ${n > cursor ? moveColorClass(t) : ''}`}
            onClick={() => onJump(n)}
            title={`跳到第 ${n} 步之后`}
          >
            {t}
          </button>
        );
      })}
    </div>
  );
}
